import React, {FC} from 'react';
import styled from 'styled-components';

import {fontWeights} from '../../../../../libs/shared/ui/src/styles/fontStyles';

/*
 * Props.
 */

interface SettingsAppsDetailsSidepanelSectionProps {
  title: React.ReactNode;
  children: React.ReactNode;
}

/*
 * Style.
 */

const StyledSectionWrapperDiv = styled.div`
  display: flex;
  flex-flow: column;
  gap: 12px;
  margin-bottom: 24px;

  &:last-child {
    margin-bottom: 0;
  }
`;

const StyledSectionTitleDiv = styled.div`
  line-height: 20px;
  font-weight: ${fontWeights.medium};
  color: ${(p) => p.theme.greys.shade90};
`;

const StyledSectionContentDiv = styled.div`
  display: flex;
  flex-flow: column;
  gap: 12px;
  line-height: 22px;
`;

/*
 * Component.
 */

export const SettingsAppsDetailsSidepanelSection: FC<SettingsAppsDetailsSidepanelSectionProps> = (props) => {
  const {title, children} = props;

  return (
    <StyledSectionWrapperDiv>
      <StyledSectionTitleDiv>{title}</StyledSectionTitleDiv>
      <StyledSectionContentDiv>{children}</StyledSectionContentDiv>
    </StyledSectionWrapperDiv>
  );
};
